import { Box, Grid } from '@mui/material';
import DateChip from 'src/components/DateChip';
import PaperPanelInfo from 'src/components/PaperPanelInfo';
import Subtitle from 'src/components/Subtitle';
import { DebentureAssetData } from 'src/types/operations/debentures';

import { formatCompetence } from '../utils';

type AssetReceivablesProps = {
  data?: DebentureAssetData;
  isLoading?: boolean;
};

export default function AssetReceivables({
  data,
  isLoading,
}: AssetReceivablesProps) {
  const receivables = data?.receivables;

  const cards = [
    { title: 'Sem atraso', value: receivables?.semAtraso },
    { title: 'Com atraso', value: receivables?.comAtraso },
    { title: 'Vencidos e não pagos', value: receivables?.vencidosNaoPagos },
    { title: 'Provisões', value: receivables?.provisoes },
    { title: 'Direitos creditórios totais', value: receivables?.total },
  ];

  return (
    <>
      <Subtitle title="Direitos Creditórios" />
      <Box display="flex" justifyContent="flex-end" alignItems="center" mb={1}>
        <DateChip
          title="Competência"
          date={formatCompetence(data?.dataReferencia)}
        />
      </Box>
      <Grid container spacing={2} sx={{ mb: 4 }}>
        {cards.map((card) => (
          <Grid item xs={12} sm={6} md key={card.title}>
            <PaperPanelInfo
              numeric
              title={card.title}
              value={card.value ?? undefined}
              loading={isLoading}
            />
          </Grid>
        ))}
      </Grid>
    </>
  );
}
